// extracted by mini-css-extract-plugin
export default {"small_italic_text":"vO","wrapper":"wO","page":"xO","topblock":"yO","nextBtn":"zO","bottomnav":"AO","MyClassEnterDone":"BO","topname":"CO","text":"EO"};
    if(module.hot) {
      // 1713996748682
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  